<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		setDoc,
		getDoc,
		updateDoc,
		collection,
		addDoc,
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		serverTimestamp,
		// increment,
		// query,
		// limit,
		// orderBy,
	} from "firebase/firestore";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	export let user;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));

	let message = {
		html: "",
		subject: "",
		text: "",
	};

	let emailClipboard = {
		to: "",
		cc: "",
		bcc: "",
	};

	let recepients = {
		to: [],
		cc: [],
		bcc: [],
	};
	let invalid = {
		to: [],
		cc: [],
		bcc: [],
	};
	let showPreview = false;

	let temp;

	function onlyUnique(value, index, array) {
		return array.indexOf(value) === index;
	}

	function splitEmailClipboard(type) {
		var emailArray = emailClipboard[type].split(/(\n|\s|,|")/);
		let valid = [];
		let nonvalid = [];
		var emailRegex =
			/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

		emailArray.forEach((item) => {
			if (emailRegex.test(item)) {
				valid.push(item);
			} else {
				nonvalid.push(item);
			}
		});

		recepients[type] = valid.filter(onlyUnique);
		invalid[type] = nonvalid.filter(onlyUnique);
		console.log(recepients[type]);
		console.log(invalid[type]);
		alert("split " + type);
	}

	async function sendMail() {
		const autoSendRef = collection(db, "autosendmail");

		await addDoc(
			autoSendRef,
			{
				to: recepients.to,
				cc: recepients.cc,
				bcc: recepients.bcc,
				message: {
					subject: message.subject,
					html: message.html,
					text: message.text,
				},
				timeOfSending: serverTimestamp(),
			},
			{ merge: true }
		).then(() => {
			console.log("DONE");
			alert("Mail sent!");
		});
	}
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>Newsletter Composer</h1>

<!-- <div class="flex flex-wrap"> -->
<div class="grid grow">
	<label for="gid">Subject:</label>
	<input
		type="text"
		name="subject"
		id="subject"
		bind:value={message.subject}
		placeholder="Email Subject"
		title="Email Subject"
	/>
</div>
<div class="grid">
	<label for="des_code">HTML Message:</label>
	<textarea
		type="text"
		name="html_compose"
		id="html_compose"
		bind:value={message.html}
		placeholder="Paste your composed HTML mail here"
		title="Paste your composed HTML mail here"
		class="text-blue-200"
	></textarea>
	<button
		on:click={() => {
			showPreview = !showPreview;
		}}
		class="primary"
		><i class="fa-solid fa-eye" data-position="left"></i> Preview</button
	>
</div>

{#if showPreview}
	<iframe
		title="Preview"
		srcdoc={message.html}
		style="width:100%; min-height:600px"
	></iframe>
{/if}

<div class="grid">
	<label for="des_code">Text Message:</label>
	<textarea
		type="text"
		name="text_compose"
		id="text_compose"
		bind:value={message.text}
		placeholder="Paste your TEXT mail here"
		title="Paste your TEXT mail here"
		class="text-blue-200"
	></textarea>
</div>
<br />
<hr />
<br />

<div class="flex flex-wrap">
	<div class="grid grow">
		<label for="des_code">TO Email Clipboard:</label>
		<textarea
			type="text"
			name="email_clipboard"
			id="email_clipboard"
			bind:value={emailClipboard.to}
			placeholder="Paste your recepients here"
			title="Paste your recepients here"
			class="text-blue-200"
		></textarea>
	</div>
	<button on:click={() => splitEmailClipboard("to")} class="primary"
		><i class="fa-solid fa-scissors"></i></button
	>
</div>
<div class="flex flex-wrap">
	<div class="grid grow">
		<label for="des_code">CC Email Clipboard:</label>
		<textarea
			type="text"
			name="email_clipboard"
			id="email_clipboard"
			bind:value={emailClipboard.cc}
			placeholder="Paste your CC recepients here"
			title="Paste your CC recepients here"
			class="text-blue-200"
		></textarea>
	</div>
	<button on:click={() => splitEmailClipboard("cc")} class="primary"
		><i class="fa-solid fa-scissors"></i></button
	>
</div>
<div class="flex flex-wrap">
	<div class="grid grow">
		<label for="des_code">BCC Email Clipboard:</label>
		<textarea
			type="text"
			name="email_clipboard"
			id="email_clipboard"
			bind:value={emailClipboard.bcc}
			placeholder="Paste your BCC recepients here"
			title="Paste your BCC recepients here"
			class="text-blue-200"
		></textarea>
	</div>
	<button on:click={() => splitEmailClipboard("bcc")} class="primary"
		><i class="fa-solid fa-scissors"></i></button
	>
</div>

<br />
<hr />
<br />

Review recepients TO:
<div class="flex flex-wrap email-display gap-1">
	{#each recepients.to as recepient, i}
		<div class="flex rounded bg-white">
			<i>
				{i + 1}
			</i>
			<input
				type="email"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={recepients.to[i]}
				class=" grow"
			/>

			<button
				on:click={() => (
					(temp = recepients.to.splice(i, 1)), (recepients.to = recepients.to)
				)}
				class="secondary"><i class="fa-solid fa-times" /></button
			>
		</div>
	{/each}
</div>
<div class="flex flex-wrap gap-1">
	{#each invalid.to as invalid_entry}
		<span class="p-1 bg-red-900 rounded">{invalid_entry}</span>
	{/each}
</div>

<button on:click={() => recepients.to.length++}>
	<i class="fa-solid fa-plus" data-position="left" />New TO</button
>
<!--  -->
<hr />
Review recepients CC:
<div class="flex flex-wrap email-display gap-1">
	{#each recepients.cc as recepient, i}
		<div class="flex rounded bg-white">
			<i>
				{i + 1}
			</i>
			<input
				type="email"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={recepients.cc[i]}
				class=" grow"
			/>

			<button
				on:click={() => (
					(temp = recepients.cc.splice(i, 1)), (recepients.cc = recepients.cc)
				)}
				class="secondary"><i class="fa-solid fa-times" /></button
			>
		</div>
	{/each}
</div>
<div class="flex flex-wrap gap-1">
	{#each invalid.cc as invalid_entry}
		<span class="p-1 bg-red-900 rounded">{invalid_entry}</span>
	{/each}
</div>

<button on:click={() => recepients.cc.length++}>
	<i class="fa-solid fa-plus" data-position="left" />New CC</button
>
<!--  -->
<hr />
Review recepients BCC:
<div class="flex flex-wrap email-display gap-1">
	{#each recepients.bcc as recepient, i}
		<div class="flex rounded bg-white">
			<i>
				{i + 1}
			</i>
			<input
				type="email"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={recepients.bcc[i]}
				class=" grow"
			/>

			<button
				on:click={() => (
					(temp = recepients.bcc.splice(i, 1)),
					(recepients.bcc = recepients.bcc)
				)}
				class="secondary"><i class="fa-solid fa-times" /></button
			>
		</div>
	{/each}
</div>
<div class="flex flex-wrap gap-1">
	{#each invalid.bcc as invalid_entry}
		<span class="p-1 bg-red-900 rounded">{invalid_entry}</span>
	{/each}
</div>

<button on:click={() => recepients.bcc.length++}>
	<i class="fa-solid fa-plus" data-position="left" />New BCC</button
>

<br />
<hr />
<br />
<div class="grid flex-wrap sm:flex">
	<button on:click={sendMail} class="order-first secondary grow sm:order-none">
		<i class="fa-solid fa-paper-plane" data-position="left" />Send Mail</button
	>
</div>
<!-- <button on:click={() => emailSet.recepients.length++}>
	<i class="fa-solid fa-plus" data-position="left" />New recepient</button
> -->

<!-- <div class="flex">
	<input type="checkbox" name="cc_" id="cc_" bind:checked={hasCC} /><label
		for="cc_">Send CC:</label
	>
</div> -->

<!-- {#if hasCC}
	{#each emailSet.cc as recepient, i}
		<div class="flex">
			<input
				type="text"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={emailSet.cc[i]}
				class=" grow"
			/>

			<i>
				{i + 1}
			</i>
			{#if i != 0}
				<button
					on:click={() => (
						(temp = emailSet.cc.splice(i, 1)), (emailSet.cc = emailSet.cc)
					)}
					class="secondary"><i class="fa-solid fa-minus" /></button
				>
			{/if}
		</div>
	{/each}
	<button on:click={() => emailSet.cc.length++}>
		<i class="fa-solid fa-plus" data-position="left" />New CC</button
	>
{/if} -->

<!-- <div class="flex">
	<input type="checkbox" name="bcc_" id="bcc_" bind:checked={hasBCC} /><label
		for="bcc_">Send BCC:</label
	>
</div> -->

<!-- {#if hasBCC}
	{#each emailSet.bcc as recepient, i}
		<div class="flex">
			<input
				type="text"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={emailSet.bcc[i]}
				class=" grow"
			/>

			<i>
				{i + 1}
			</i>
			{#if i != 0}
				<button
					on:click={() => (
						(temp = emailSet.bcc.splice(i, 1)), (emailSet.bcc = emailSet.bcc)
					)}
					class="secondary"><i class="fa-solid fa-minus" /></button
				>
			{/if}
		</div>
	{/each}
	<button on:click={() => emailSet.bcc.length++}>
		<i class="fa-solid fa-plus" data-position="left" />New BCC</button
	>
{/if} -->

<!-- <div class="grid flex-wrap sm:flex">
	<button
		on:click={sendEmailWithCode}
		class="order-first secondary grow sm:order-none"
	>
		<i class="fa-solid fa-envelope" data-position="left" />Send Email with Code</button
	>
</div> -->

<div class="grid gap-4" />

<style>
	:global(.obelisk select) {
		box-sizing: border-box;

		place-content: center;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity));
	}
	:global(.obelisk select) {
		margin: 10px;
		padding: 15px;
		border-radius: 0px;
		box-shadow: #093a86 5px 5px 0;
		color: #05204a;
	}
	.email-display > div {
		overflow: hidden;
	}
	.email-display i {
		opacity: 0.4;
		color: #05204a;
		padding: 4px 8px;
	}
	.email-display input {
		margin: 0;
		padding: 4px;
		box-shadow: none;
	}
	.email-display button {
		margin: 0;
		padding: 4px 8px;
		box-shadow: none;
	}
	textarea {
		padding: 4px;
	}
</style>
